// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-other{text-align:left;margin-top:30px}.otherJob{color:#333;font-size:16px;line-height:21px;font-weight:700;background:#d5dee6;margin:-5px -30px;text-align:center;padding:30px 0 10px}.company-list .row{padding:30px}.more-jobs{background:#2b59c3 0 0 no-repeat padding-box;border-radius:20px;padding:5px 20px;margin:0 auto;color:#fff}.more-jobs:hover{color:#fff}", ""]);
// Exports
module.exports = exports;
